import res from 'res'; //Detects dpi and resolution
import Scrollbar from './components/scrollbar.js';

let Media = {
    breakpoints: {
        lg: 1600,
        md: 1199,
        sm: 991,
        xs: 767
    },
    detect: function() {
        let isDesktopHD, isDesktop, isTablet, isMobile;
        let brpDesktopHD = Media.breakpoints.lg;
        let brpDesktop = Media.breakpoints.md;
        let brpTablet = Media.breakpoints.sm;
        let brpMobile = Media.breakpoints.xs;
        let windowWidth = $('body').width() + Scrollbar.getWidth();

        let mediaObj = {
            isDesktopHD: windowWidth >= brpDesktopHD,
            isDesktop: windowWidth >= brpTablet,
            isTablet: windowWidth > brpMobile && windowWidth < brpTablet,
            isMobile: windowWidth <= brpMobile,
            isTouch: Media.isTouchDevice()
        };

        function getCurrentBP() {
            for (var bp in mediaObj) {
                if (mediaObj[bp] == true) return bp;
            }
        }

        mediaObj.current = getCurrentBP();

        return mediaObj;
    },
    isTouchDevice() {
        return (/(ipad|iphone|android|mobile|touch)/i.test(navigator.userAgent));
    }
}


$(function() {

    var MediaQ = Media.detect();
    var mediaTO = false;

    //initial bp trigger
    setTimeout(function() {
        $(window).trigger('mdbreakpoint', [false, MediaQ.current]);
    }, 0);

    var timeout;
    window.addEventListener('resize', event => {
        if (mediaTO) clearTimeout(mediaTO);
        mediaTO = setTimeout(function() {
            var newMediaQ = Media.detect();
            if (MediaQ.current != newMediaQ.current) {
                $(window).trigger('mdbreakpoint', [MediaQ.current, newMediaQ.current]);
            }
            MediaQ = newMediaQ;
        }, 100);
    });

    // BX.addClass не работает samsung android
    // добавляем touch класс
    if (Media.isTouchDevice()){
        $('html').addClass('bx-touch');
        $('html').removeClass('bx-no-touch');
    } else {
        $('html').addClass('bx-no-touch');
        $('html').removeClass('bx-touch');
    }

});

export default {
    detect: Media.detect,
    breakpoints: Media.breakpoints,
    isTouchDevice: Media.isTouchDevice,
    dppx: res.dppx()
};



// WEBPACK FOOTER //
// ./mediaDetect.js